import { render, staticRenderFns } from "./SupplierDetailsForm.vue?vue&type=template&id=88cc86de&scoped=true&"
import script from "./SupplierDetailsForm.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc86de",
  null
  
)

export default component.exports